import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import PosterCard from '@/components/feature/PosterCard';

interface HotSectionProps {
  items: Movie[];
}

export default function HotSection({ items }: HotSectionProps) {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="flex items-end justify-between gap-4 mb-5">
        <div className="flex items-center gap-3">
          <span className="w-1.5 h-7 rounded-full bg-accent-500"></span>
          <div>
            <h2 className="font-heading font-black text-xl md:text-2xl text-foreground-900">热门推荐</h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">根据播放热度实时更新的精彩内容</p>
          </div>
        </div>
        <Link
          to="/category/movie"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-700 hover:text-accent-600 whitespace-nowrap transition-colors cursor-pointer"
        >
          更多推荐
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
        {items.map((movie) => (
          <PosterCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}